import React from 'react'
import { Link } from 'gatsby'
import tw, { styled } from 'twin.macro'

//import LockSVG from '../../assets/lock.inline.svg'

type MenuTreeLink = {
    link: {
        title: string,
        url: string,
        options: {
            attributes: {
                target?: string,
                class?: string,

            }
        }
    },

}

type MenuProps = {
    tree: Array<MenuTreeLink>,
    className?: string
}

const AuxiliaryMenu: React.FC<MenuProps> = ({ tree, className }) => {

    return (
        <Style className={[ className, "navigation__aux auxiliary-menu"].join(' ')}>
            {tree.map((item, i:number) => (
                <li key={`top-${i}`}>
                    {item.link.options?.attributes?.target ? (
                        <a
                            href={item.link.url}
                            {...convertClassAttribute(item.link.options?.attributes)}
                        >{item.link.url.includes('novahub') ? <span className="rounded__Style-kvSNIU material-icons material-icons-round mr-1">person</span> : ''}{item.link.title}</a>
                    ) : (
                        <Link
                            {...convertClassAttribute(item.link.options?.attributes)}
                            to={item.link.url.replace(`/${process.env.GATSBY_SITE}/`, '/')}
                        >{item.link.title}
                        {/*item.subtree.length > 0 && <span className="material-icons material-icons-round">expand_more</span>*/}
                        </Link>
                    )}
                    {/*item.subtree.length > 0 && (
                        <ul className="auxiliary-menu__submenu">
                            {item.subtree.map(item2 => (
                                <li key={item2.link.url}>
                                    <Link
                                        to={item2.link.url}
                                    >{item2.link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                            )*/}
                </li>
            ))}
        </Style>
    )
}
export default AuxiliaryMenu;

const convertClassAttribute = props => {


    return {
        ...props,
        className: props.className.join(' ')
    }
}

const Style = styled.ul`
    ${tw `m-0 hidden lg:flex text-sm gap-x-3 xl:gap-x-5 items-center`}

    > li {
        ${tw `mb-0 relative`}

        &:hover > .auxiliary-menu__submenu {
            ${tw `block`}
        }
    }

    a {
        ${tw `text-default text-sm xl:fontSize[17px]! font-semibold hover:text-primary flex items-center`}

        &.highlight {
            ${tw `text-default rounded-xl py-1 leading-none ps-2 pe-3 border bg-primary border-primary border-[3px] hover:bg-black hover:border-black hover:text-white focus-visible:bg-orange motion-safe:transition-colors`}
        }

        &.button {
            ${tw `bg-transparent border border-primary border-[3px] rounded-xl py-2 leading-none px-4 text-black hover:bg-black hover:border-black hover:text-white motion-safe:transition-colors text-sm! xl:fontSize[17px]! focus-visible:bg-orange focus-visible:text-white!`}
        }

        &[aria-current="page"] {
            ${tw `text-default`}
        }
    }

    .auxiliary-menu__submenu {
        ${tw `absolute bg-white text-sm text-left min-w-full shadow hidden z-10 m-0! rounded overflow-hidden divide-y divide-gray-200 `}

        > li {
            ${tw `mb-0`}
        }

        a {
            ${tw `p-2 truncate`}
        }
    }
`